<div class="content-container">
  <clr-wizard #wizardxl [(clrWizardOpen)]="xlOpen">
    <clr-wizard-title>Производство на полуфабрикати</clr-wizard-title>

    <!-- <clr-wizard-button [type]="'cancel'">Cancel</clr-wizard-button>
    <clr-wizard-button [type]="'previous'">Back</clr-wizard-button>
    <clr-wizard-button [type]="'next'">Next</clr-wizard-button>
    <clr-wizard-button [type]="'finish'">Finish</clr-wizard-button> -->

    <clr-wizard-page #loadPoPage>
      <ng-template clrPageTitle>Производствена Поръчка</ng-template>
      <div class="card">
        <div class="card-header">Поръчка за производство</div>
        <div class="card-block">
          <form clrForm [formGroup]="filterPoForm">
            <clr-input-container>
              <label>Номер</label>
              <input clrInput formControlName="DocumentNo" autocomplete="off" />
              <clr-control-error *clrIfError="'required'"
                >Грешка</clr-control-error
              >
            </clr-input-container>
          </form>

          <div *ngIf="poList.length > 0">
            <hr>
            <h4>Има повече от едно ПН с този номер. Моля изберете:</h4>
            <hr>
            <ul class="list compact">
              <li *ngFor="let po of poList" (click)="selectPoFromMultiple(po)">{{po.DocumentType?.TypeName?.BG}} {{po.DocumentNo}} - {{po.DocumentDate | date }}</li>
            </ul>
            <hr>
          </div>
        </div>
        <div class="card-footer">
          <button class="btn btn-primary" type="submit" (click)="loadPoOrders()">
            Зареди
          </button>
          <button class="btn" type="button" (click)="resetPoForm()">
            Изчисти
          </button>
        </div>
      </div>
    </clr-wizard-page>

    <clr-wizard-page
      #checkRecipePage
      [clrWizardPageNextDisabled]="disableNextToStepThree"
    >
      <ng-template clrPageTitle>Преглед на технологиите</ng-template>
      <div class="card">
        <div class="card-header">Преглед на технологиите</div>
        <div class="card-block">
          <subproducts-tree
            *ngIf="processRecipe"
            [po]="productionOrder"
            [recepiesToProcess]="recepiesToProcess"
            [parent]="this"
            [allowQuantityChange]="true"
          >
          </subproducts-tree>
        </div>
      </div>

      <ng-template clrPageButtons>
        <clr-wizard-button [type]="'next'">Напред</clr-wizard-button>
      </ng-template>
    </clr-wizard-page>

    <clr-wizard-page #settings>
      <ng-template clrPageTitle>Настройки</ng-template>
      <div class="clr-row">
        <div class="clr-col">
          <div class="card">
            <div class="card-header">Настройки</div>
            <div class="card-block">
              <form clrForm [formGroup]="settingsForm">
                <clr-radio-container clrInline>
                  <label>Режим</label>
                  <clr-radio-wrapper>
                    <input
                      type="radio"
                      value="true"
                      clrRadio
                      formControlName="group"
                    />
                    <label>Групирай</label>
                  </clr-radio-wrapper>
                  <clr-radio-wrapper>
                    <input
                      type="radio"
                      value="false"
                      clrRadio
                      formControlName="group"
                    />
                    <label>Отделни</label>
                  </clr-radio-wrapper>
                  <clr-control-helper
                    >При избиране на "Групирай" групира полуфабрикатите от едно
                    ниво в едно Производствено нареждане</clr-control-helper
                  >
                </clr-radio-container>

                <clr-datalist-container>
                  <label>Тип ПН</label>
                  <input
                    clrDatalistInput
                    formControlName="documentType"
                    autocomplete="off"
                  />
                  <datalist>
                    <option
                      *ngFor="let item of documentTypeOptions"
                      [value]="item.TypeName.BG"
                    ></option>
                  </datalist>
                </clr-datalist-container>

                <clr-checkbox-container>
                  <label>Връзка родител/дете</label>
                  <clr-checkbox-wrapper>
                    <input type="checkbox" clrCheckbox formControlName="linkParent" name="Връзка родител/дете" />
                  </clr-checkbox-wrapper>
                  <clr-control-helper>
                    Ако е включено добавя връзка към родителски документ
                    <!-- <br>Ако има дефинирана ПХ за документ с код ref_doc автоматично я попълва с номер на родителски документ -->
                  </clr-control-helper>
                </clr-checkbox-container>

                <clr-checkbox-container>
                  <label>Събери количествата на едно ниво</label>
                  <clr-checkbox-wrapper>
                    <input type="checkbox" clrCheckbox formControlName="sumQuantities" name="Събери количествата" />
                  </clr-checkbox-wrapper>
                  <clr-control-helper>
                    Работи само при Режим: Групирай. Сумира изделията на едно ниво.
                  </clr-control-helper>
                </clr-checkbox-container>

                <clr-datalist-container>
                  <label>Склад продукция</label>
                  <input
                    clrDatalistInput
                    formControlName="productsStore"
                    autocomplete="off"
                  />
                  <datalist>
                    <option
                      *ngFor="let item of storeOptions | storeFilter:productionOrder"
                      [value]="item.Name.BG"
                    ></option>
                  </datalist>
                </clr-datalist-container>

                <clr-datalist-container>
                  <label>Склад материали</label>
                  <input
                    clrDatalistInput
                    formControlName="materialsStore"
                    autocomplete="off"
                  />
                  <datalist>
                    <option
                      *ngFor="let item of storeOptions | storeFilter:productionOrder"
                      [value]="item.Name.BG"
                    ></option>
                  </datalist>
                </clr-datalist-container>

                <clr-datalist-container>
                  <label>Статус</label>
                  <input
                    clrDatalistInput
                    formControlName="status"
                    autocomplete="off"
                  />
                  <datalist>
                    <option
                      *ngFor="let item of stateOptions"
                      [value]="item.name"
                    ></option>
                  </datalist>
                </clr-datalist-container>

                <clr-datalist-container *ngIf="userStateOptions?.length > 0">
                  <label>Потребителски статус</label>
                  <input
                    clrDatalistInput
                    formControlName="userStatus"
                    autocomplete="off"
                  />
                  <datalist>
                    <option
                      *ngFor="let item of userStateOptions"
                      [value]="item.UserStatusName.BG"
                    ></option>
                  </datalist>
                </clr-datalist-container>

              </form>
            </div>
          </div>
        </div>
      </div>

      <ng-template clrPageButtons>
        <clr-wizard-button [type]="'next'">Напред</clr-wizard-button>
      </ng-template>
    </clr-wizard-page>

    <clr-wizard-page #settings>
      <ng-template clrPageTitle>Обработка</ng-template>
      <div class="clr-row">
        <div class="clr-col">
          <div class="card">
            <div class="card-header">Стартирай Обработка</div>
            <div class="card-block">
              <button
                [disabled]="disableProcessButton"
                class="btn btn-outline"
                (click)="startProcessing()"
              >
                Стартирай обработката
              </button>
            </div>
            <div class="card-block">
              <log-monitor
                [logStream]="executionLog | async"
                theme="dark"
                title="Лог на обработката"
                [animated]="true"
                [icons]="true"
              ></log-monitor>
            </div>
          </div>
        </div>
      </div>
    </clr-wizard-page>
  </clr-wizard>
</div>
